import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

export default function Login() {
  const { usuario, carregando, login } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: "", senha: "" });
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  // Se já estiver logado, manda direto pra área do cliente
  useEffect(() => {
    if (!carregando && usuario) {
      navigate("/area-cliente", { replace: true });
    }
  }, [carregando, usuario, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");

    if (!form.email || !form.senha) {
      setErro("Preencha e-mail e senha.");
      return;
    }

    setEnviando(true);
    const res = await login(form.email, form.senha);
    setEnviando(false);

    if (res.ok) {
      navigate("/area-cliente");
    } else {
      setErro(res.erro || "E-mail ou senha inválidos.");
    }
  };

  return (
    <section
      className="section"
      style={{ minHeight: "80vh", display: "flex", alignItems: "center" }}
    >
      <div className="container" style={{ maxWidth: "420px" }}>
        <div className="card" style={{ "--accent": "#0066FF", padding: "40px" }}>
          <div className="tag">Acesso</div>
          <h1
            className="section-title"
            style={{ fontSize: "28px", marginBottom: "8px", color: "var(--text-primary)" }}
          >
            Entrar
          </h1>
          <p className="section-subtitle" style={{ marginBottom: "28px" }}>
            Acesse a área do cliente sepolTECH.
          </p>

          {erro && (
            <div
              style={{
                background: "rgba(239,68,68,.1)",
                border: "1px solid rgba(239,68,68,.3)",
                color: "var(--error)",
                padding: "12px 16px",
                borderRadius: "8px",
                marginBottom: "20px",
                fontSize: "14px",
              }}
            >
              {erro}
            </div>
          )}

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>E-mail</label>
              <input
                type="email"
                name="email"
                required
                value={form.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Senha</label>
              <input
                type="password"
                name="senha"
                required
                value={form.senha}
                onChange={handleChange}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={enviando}
              style={{
                marginTop: "8px",
                border: "none",
                cursor: enviando ? "default" : "pointer",
                width: "100%",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: enviando ? 0.7 : 1,
              }}
            >
              {enviando ? "Entrando..." : "Entrar →"}
            </button>
          </form>

          <p
            style={{
              fontSize: "13px",
              color: "var(--text-muted)",
              marginTop: "20px",
              textAlign: "center",
            }}
          >
            Não tem conta?{" "}
            <Link to="/cadastro" style={{ color: "var(--brand-blue)" }}>
              Cadastre-se
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
